

export default {
    state:{
        facturasFel:[],
        regimen:'',
        tipo:'',
    },
    mutations:{
        setFacturas(state,item){
            state.facturasFel.push(item)
        },
        deleteFacturas(state){
            state.facturasFel=[]
        },
        setRegimen(state,regimen){
            state.regimen=regimen
        },
        setTipo(state,item){
            state.tipo=item
        },
        deleteFac(state,index){
            state.facturasFel.splice(index, 1)
        }
    },
    actions:{
        setFacturas({commit},item){
            commit("setFacturas",item)
        },
        deleteFac({commit},index){
            
            commit("deleteFac",index)
        },
        deleteFacturas({commit}){
            commit("deleteFacturas")
        },
        setRegimen({commit},item){
            commit("setRegimen",item)
        },
        setTipo({commit},item){
            commit("setTipo",item)
        }
    },
    getters:{
        getFacturas(state){
            return state.facturasFel
        },
        getRegimen(state){
            return state.regimen
        },
        getTipo(state){
            return state.tipo
        },
    }
}